import React, { useContext } from "react";
import BillingDetails from "./BillingDetails";
import mainContext from "../context/MainContext/mainContext";
import BillingContentCompleted from "./BillingContentCompleted";

const CompletedTab = () => {
  const { id } = useContext(mainContext);

  return <>{id ? <BillingDetails /> : <BillingContentCompleted />}</>;
};

export default CompletedTab;
